var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CInputCheckbox',{attrs:{"label":_vm.label,"value":_vm.item.id,"checked":_vm.activeItems.filter(id => id === _vm.item.id).length > 0},on:{"update:checked":_vm.checked}})
}
var staticRenderFns = []

export { render, staticRenderFns }